import { createSelector } from 'reselect';

const findingsSelector = state => state.findings;

const selectLocation = state => state.location;

/*
Get the list of findings
*/

const getFindings = (findingsStore) => {
  const findings = findingsStore.get('findings');

  return findings;
};

export const findingsListSelector =
  createSelector([
    findingsSelector,
  ], getFindings);

/*
Get the finding ID
*/

const getFindingId = (location) => {
  const { payload = {} } = location;

  const { id1 = '' } = payload;

  return id1;
};

export const findingIdSelector =
  createSelector([
    selectLocation,
  ], getFindingId);


/*
Get finding by ID
*/

const getFindingById = (findings, findingId) => {
  const finding = findings.get('findings').find(f => f.id === findingId);

  return finding;
};

export const findingByIdSelector =
  createSelector([
    findingsSelector,
    findingIdSelector,
  ], getFindingById);


/*
Get finding fields for superadmin support section
*/

// Finding fields used/displayed in superadmin support section.
// The field is displayed iff the attribute value is 'true'.
const FINDING_SUPPORT_KEYS = {
  jurisdiction: true,
  jurisdictionName: false,
  matchId: true,
  promotedToId: true,
  modified: true,
  modifiedByName: true,
  statusModifiedByName: true,
  resolution: true,
  resolutionNotes: true,
};

// Converts camelCase finding keys above to snakeCase
const camelToSnake = string => string
  .replace(
    /[\w]([A-Z])/g,
    m => (`${m[0]}_${m[1]}`)
  )
  .toLowerCase();

const getSupportFields = (finding) => {
  const findingPropsList = Object.keys(FINDING_SUPPORT_KEYS)
    .map((key) => {
      const obj = {
        display: FINDING_SUPPORT_KEYS[key],
        key,
        label: camelToSnake(key),
        value: finding[key],
      };
      return obj;
    });

  return findingPropsList;
};

export const findingSupportFieldsSelector =
  createSelector([
    findingByIdSelector,
  ], getSupportFields);

/*
Findings Error Selector
*/

const getFindingsError = (findings) => {
  const error = findings.get('findingsError');

  return error;
};

export const findingsErrorSelector =
  createSelector([
    findingsSelector,
  ], getFindingsError);

/*
Constants selector
*/

const getConstants = (findingsStore) => {
  const constants = findingsStore.get('constants');

  return constants;
};

export const constantsSelector =
  createSelector([
    findingsSelector,
  ], getConstants);


/*
Resolution constant selector
*/

const getResolution = (constants) => {
  const resolution = constants.resolution || {};

  return resolution;
};

export const resolutionSelector =
  createSelector([
    constantsSelector,
  ], getResolution);


/*
Get Resolution options for superadmin support page
*/


const getResolutionOptions = (resolution) => {
  const options = resolution.selectOptions || [];

  return options;
};

export const resolutionOptionsSelector =
  createSelector([
    resolutionSelector,
  ], getResolutionOptions);
